import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipOverAskBaseComponent } from '../betslip-overask-base.component';

@Component({
    selector: 'bs-digital-over-ask',
    templateUrl: './betslip-over-ask.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./betslip-over-ask.component.scss'],
    standalone: false,
})
export class BetslipOverAskComponent extends BetslipOverAskBaseComponent implements OnInit {
    @Input() inColumn = false;

    constructor(store: Store<IBetslipRootState>, changeDetector: ChangeDetectorRef) {
        super(store, changeDetector);
    }
}
